import * as api from "../api/resendOtpApi";
import * as types from "../constants/ActionTypes";

import { FormattedMessage } from "react-intl";
import React from "react";
import { showNotification } from "./notificationsActions";

export const resendOtp = ({
  email, 
  type, 
  accountId
}) => async dispatch => {
  try {
    const resp_json = await api.resendOtp({
      email, 
      type, 
      accountId
    }); 
    if (resp_json) {
      //success, redirect to portal
      dispatch(reIssueSucceeded(type));
    }
    else{
      dispatch(reIssueFailed(type));
    }
  } catch (err) {
    const response = err.response && (await err.response.json());
    const errorMessages = (response && response.errors) || [
      <FormattedMessage
        id="genericError"
        defaultMessage="An unexpected error occurred and our engineering team has been notified. Please try again in a few moments."
      />
    ];
    for (let message of errorMessages) {
      dispatch(
        showNotification({
          message,
          notificationType: "error",
          dismissDelay: 3000
        })
      );
    }
  }
};

const reIssueSucceeded = (type) => ({
  type: types.RE_SEND_OTP_SUCCEEDED,
  verification_type: type
});

const reIssueFailed = (type) => ({
  type: types.RE_SEND_OTP_FAILED,
  verification_type: type
});